import * as ACTIONS from "@iso/redux/specificationsCategories/actionTypes";

const initialState = {
  specificationsCategories: {
    list: [],
    total: 0,
  },
};

function specificationsCategoriesReducer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case ACTIONS.GET_SPECIFICATIONS_CATEGORIES_SUCCESS: {
      return {
        ...state,
        ...{ specificationsCategories: payload },
      };
    }

    default:
      return state;
  }
}

export default specificationsCategoriesReducer;
